/**
 * Справочник типов мероприятий. Без импортов из `payload` — файл
 * используют и серверный конфиг, и клиентская форма заявки.
 */
export const EVENT_TYPES = [
  { value: 'corporate', label: 'Корпоратив' },
  { value: 'private', label: 'Частное мероприятие' },
  { value: 'tournament', label: 'Турнир' },
  { value: 'training', label: 'Тренировочный интенсив' },
] as const

export type EventType = (typeof EVENT_TYPES)[number]['value']

export const eventTypeLabel = (v?: string | null) => EVENT_TYPES.find((t) => t.value === v)?.label ?? ''
